(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logos"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const track = document.querySelector(".brands-track");
  const items = document.querySelectorAll(".brands-item");
  const pagination = document.querySelector(".brands-pagination");
  let index = 0;
  let interval;

  function updateSlider() {
    const screenWidth = window.innerWidth;
    const itemsPerView = screenWidth < 768 ? 1 : 6;
    const total = items.length;
    const maxIndex = Math.ceil(total / itemsPerView) - 1;

    track.style.transform = `translateX(-${index * 100}%)`;

    // Pagination only for mobile
    if (screenWidth < 768) {
      pagination.innerHTML = "";
      for (let i = 0; i <= maxIndex; i++) {
        const btn = document.createElement("button");
        if (i === index) btn.classList.add("active");
        btn.addEventListener("click", () => {
          index = i;
          resetInterval();
          updateSlider();
        });
        pagination.appendChild(btn);
      }
    }
  }

  function nextSlide() {
    const screenWidth = window.innerWidth;
    const itemsPerView = screenWidth < 768 ? 1 : 6;
    const total = items.length;
    const maxIndex = Math.ceil(total / itemsPerView) - 1;
    index = (index + 1) > maxIndex ? 0 : index + 1;
    updateSlider();
  }

  function resetInterval() {
    clearInterval(interval);
    interval = setInterval(nextSlide, 2000);
  }

  window.addEventListener("resize", updateSlider);
  resetInterval();
  updateSlider();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maquillage"] && !Shopify.designMode) return;
  try {
    
  const carousel = document.getElementById('productsCarousel');
  const progressBar = document.getElementById('progressBar');

  if(carousel){
    carousel.addEventListener('scroll', () => {
      const scrollLeft = carousel.scrollLeft;
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;
      let progress = (scrollLeft / maxScroll) * 100;

      progress = Math.max(progress, 10);
      progressBar.style.width = progress + "%";
    });
  }

  } catch(e) { console.error(e); }
})();
})();
